import type { AutocompleteOption } from "@/components/LockedAutocomplete";
import type { ProjectSearchHit } from "@/features/timesheetFlow/timesheetFlowApi";
import { formatAuftragNumberWithYear } from "@/lib/orderDraftUtils";
import type { TimesheetProjectPreset } from "@/features/timesheetFlow/timesheetFlowTypes";

export const TIMESHEET_PROJECT_PICKER_PLACEHOLDER =
  "Klicken für zuletzt benutzte – oder Nummer / Kunde / Ort tippen …";

export const TIMESHEET_PROJECT_PICKER_EMPTY =
  "Noch keine Aufträge benutzt – tippe eine Nummer, einen Kunden oder einen Ort.";

/** Ort und Ort-Zusatz in einer Zeile, analog zum Stundennachweis-PDF. */
export function formatTimesheetOrt(
  ort?: string | null,
  ortZusatz?: string | null,
): string {
  return [ort, ortZusatz]
    .map((s) => String(s || "").trim())
    .filter(Boolean)
    .join(" ");
}

/** Zwei Zeilen wie Materialanforderung: Nummer oben, Kunde · Ort · Beschreibung unten. */
export function projectSearchHitToOption(
  hit: ProjectSearchHit,
): AutocompleteOption<ProjectSearchHit> {
  return {
    key: String(hit.id),
    label: formatAuftragNumberWithYear(hit),
    description: [hit.kunde, formatTimesheetOrt(hit.ort, hit.ort_zusatz), hit.beschreibung]
      .filter((v): v is string => !!v)
      .join(" · "),
    value: hit,
  };
}

export function projectSearchHitToPreset(hit: ProjectSearchHit): TimesheetProjectPreset {
  return {
    id: hit.id,
    auftragsnummer: hit.auftragsnummer,
    jahr: hit.jahr,
    kunde: hit.kunde,
    ort: hit.ort,
    ort_zusatz: hit.ort_zusatz,
    hero_project_id: hit.hero_project_id,
    kunden_id: hit.kunden_id,
    ordner_id: hit.ordner_id,
    sordner_id: hit.sordner_id,
    auftragsart: hit.auftragsart,
    hero_custom_fields: hit.hero_custom_fields,
  };
}
